import Flex from 'components/Layout/components/Flex';
import type { ProductListResultViewModel } from 'autogen/swagger/all';
import styled from 'styled-components';
import Layout from 'components/Layout';
import { ColorNeutralGrey3, ColorNeutralWhite, Spacing16, Spacing32 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes, zIndex } from 'variables';
import { animated } from '@react-spring/web';
import QuickSearch from 'components/QuickSearch';
import { hideOnMobile } from 'components/pages/Checkout/components/Delivery/shared/styles';
import { memo, useContext } from 'react';
import FilterMenuOpenerRenderer from './Filters/FilterMenuOpenerRenderer';
import { SearchTextContext } from 'components/pages/Search/hooks/contexts';
import useIsAppRequest from 'hooks/user/useIsAppRequest';

/* #region styles */
const StickyHeader = styled<any>(animated.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: ${Spacing16} 0;
    background-color: ${ColorNeutralWhite};
    border-bottom: 1px solid ${ColorNeutralGrey3};
    z-index: ${zIndex.fixed};
`;

const CustomContent = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${Spacing32};

    ${breakpoint.up(sizes.lg)} {
        grid-template-columns: 1fr 4fr;
    }
`;

const Column = styled(Flex.Column)`
    min-width: 0;
    ${breakpoint.up(sizes.sm)} {
        align-items: start;
    }
`;
/* #endregion */

const StickyFilterHeader = ({ model, ...restProps }: { model: ProductListResultViewModel } & { [x: string]: any }) => {
    const { searchText } = useContext(SearchTextContext) || {};
    const isAppRequest = useIsAppRequest();

    return (
        <StickyHeader {...restProps}>
            <Layout.Section contentRenderer={(children) => <CustomContent>{children}</CustomContent>}>
                <div css={hideOnMobile} />
                <Column>
                    {/* Sticky filter header has quickSearch */}
                    {!isAppRequest && <QuickSearch shouldDisplayCameraButton={false} searchText={searchText} />}
                    {/* Renders all filter menu openers */}
                    <FilterMenuOpenerRenderer model={model} />
                </Column>
            </Layout.Section>
        </StickyHeader>
    );
};

export default memo(StickyFilterHeader);
